// A template line item — the shape stored in BomTemplate.LineItemsJson, mirroring
// the server's TemplateLineItem record. All fields optional/nullable. priceByRange
// + unitCostByRangeJson are PRESERVED read-only by the III-B editor (nested range
// editing deferred); they round-trip untouched.
export interface TemplateLineItem {
  itemId: number | null;
  itemName: string | null;
  calcType: string | null;
  calcFactor: number | null;
  unitCost: number | null;
  unitCurrencyCode: string | null;
  priceByRange: boolean;
  unitCostByRangeJson: string | null;
  supplierId: number | null;
  itemiseOnQuote: boolean;
  note: string | null;
}

export function blankTemplateLineItem(): TemplateLineItem {
  return {
    itemId: null,
    itemName: null,
    calcType: null,
    calcFactor: null,
    unitCost: null,
    unitCurrencyCode: "AUD",
    priceByRange: false,
    unitCostByRangeJson: null,
    supplierId: null,
    itemiseOnQuote: false,
    note: null,
  };
}

function numOrNull(v: unknown): number | null {
  if (v == null || v === "") return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

function strOrNull(v: unknown): string | null {
  return typeof v === "string" && v !== "" ? v : null;
}

export function parseTemplateLineItems(json: string | null | undefined): TemplateLineItem[] {
  if (!json || !json.trim()) return [];
  try {
    const v: unknown = JSON.parse(json);
    if (!Array.isArray(v)) return [];
    return v.map((raw) => {
      const c = raw as Record<string, unknown>;
      return {
        itemId: numOrNull(c.itemId),
        itemName: strOrNull(c.itemName),
        calcType: strOrNull(c.calcType),
        calcFactor: numOrNull(c.calcFactor),
        unitCost: numOrNull(c.unitCost),
        unitCurrencyCode: strOrNull(c.unitCurrencyCode) ?? "AUD",
        priceByRange: c.priceByRange === true,
        unitCostByRangeJson: strOrNull(c.unitCostByRangeJson),
        supplierId: numOrNull(c.supplierId),
        itemiseOnQuote: c.itemiseOnQuote === true,
        note: strOrNull(c.note),
      };
    });
  } catch {
    return [];
  }
}

export function serializeTemplateLineItems(items: TemplateLineItem[]): string {
  return JSON.stringify(items);
}
